import { render, staticRenderFns } from "./ed-calls-info.component.vue?vue&type=template&id=43e497da&scoped=true&"
import script from "./ed-calls-info.component.ts?vue&type=script&lang=ts&"
export * from "./ed-calls-info.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-calls-info.view.scss?vue&type=style&index=0&id=43e497da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e497da",
  null
  
)

export default component.exports